import * as React from "react"
export const Svg_013 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={58}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M29 22.654c.875 0 1.586-.712 1.586-1.586v-3.82c0-.874-.711-1.585-1.586-1.585-.875 0-1.586.711-1.586 1.586v3.819c0 .874.711 1.586 1.586 1.586Z"
      />
      <path
        fill="url(#c)"
        d="M42.027 15.663c-.874 0-1.586.711-1.586 1.585v3.82c0 .874.712 1.586 1.586 1.586.875 0 1.586-.712 1.586-1.586v-3.82c0-.874-.711-1.585-1.586-1.585Z"
      />
      <path
        fill="url(#d)"
        d="M49.506 8.494C44.03 3.017 36.746 0 29 0S13.971 3.017 8.494 8.494 0 21.254 0 29s3.017 15.029 8.494 20.506S21.254 58 29 58s15.029-3.017 20.506-8.494S58 36.746 58 29s-3.017-15.029-8.494-20.506Zm-25.49 8.755A4.99 4.99 0 0 1 29 12.264a4.99 4.99 0 0 1 4.984 4.985v3.819A4.99 4.99 0 0 1 29 26.052a4.99 4.99 0 0 1-4.984-4.984v-3.82Zm-6.968 24.698h-3.399v-3.399h3.399v3.399Zm4.14-15.895h-8.845v-3.398h2.723v-5.108a5.769 5.769 0 0 1-2.404.522h-.32v-3.399h.32a2.407 2.407 0 0 0 2.404-2.405h3.399v10.39h2.723v3.398Zm7.163 12.496h1.297a5.18 5.18 0 0 1 5.175 5.175A5.183 5.183 0 0 1 30.7 48.79v2.27h-3.398v-2.2a4.733 4.733 0 0 1-4.124-4.689h3.398a1.33 1.33 0 0 0 1.328 1.328h1.746c.98 0 1.776-.797 1.776-1.776 0-.98-.797-1.776-1.776-1.776h-1.297a5.18 5.18 0 0 1-5.175-5.175 5.183 5.183 0 0 1 4.124-5.067v-2.27h3.398v2.201a4.733 4.733 0 0 1 4.124 4.688h-3.398a1.33 1.33 0 0 0-1.328-1.328h-1.746c-.979 0-1.776.797-1.776 1.776 0 .98.797 1.776 1.776 1.776Zm16 3.399h-3.399v-3.399h3.399v3.399Zm2.66-20.88a4.99 4.99 0 0 1-4.984 4.985 4.99 4.99 0 0 1-4.984-4.984v-3.82a4.99 4.99 0 0 1 4.984-4.984 4.99 4.99 0 0 1 4.985 4.985v3.819Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={28.148}
        x2={31.69}
        y1={16.711}
        y2={19.313}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={41.175}
        x2={44.718}
        y1={16.711}
        y2={19.313}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.412}
        x2={40.962}
        y1={8.7}
        y2={53.288}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h58v58H0z" />
      </clipPath>
    </defs>
  </svg>
)